export default __webpack_public_path__ + "static/media/02_HsnTungYang.1ac81bd3.png";